<template>
  <header class="header">
    <section class="content">
      <div class="game-info" v-if="isMobile">
        <div class="logo-wrapper">
          <a href="./index.html">
            <img class="logo" src="../assets/img/logo.png" alt="">
          </a>
        </div>
        <div class="title">
          <p class="title-main">輪迴幻想</p>
          <p class="title-child">這一次，逆行時空，只為妳</p>
        </div>
        <a class="m-downnload" href="https://jy.onelink.me/5PpE?pid=officialsite&c=qrcode" target="_blank" v-if="isMobile"></a>
        <a href="javascript:void(0);" class="music" v-if="isMobile"><span class="music-icon" @click="controlMusic"></span></a>
        <span class="m-menu" v-if="isMobile && !showSubMenu" @click="showSubMenu = true"></span>
        <span class="m-close" v-if="showSubMenu" @click="showSubMenu = false"></span>
      </div>
      <transition name="fadeIn">
        <div class="link-wrapper" v-if="!isMobile || (isMobile && showSubMenu)">
          <a class="link" :class="{active: navArticleType === ''}" href="./index.html"><span>官網首頁</span></a>
          <a class="link" :class="{active: newsActive}" href="./index.html#/article-list?type=all" @click="toSetNavArticleType('all')"><span>最新資訊</span></a>
          <a class="link" :class="{active: navArticleType ==='events'}" href="./index.html#/article-list?type=events" @click="toSetNavArticleType('events')"><span>遊戲活動</span></a>
          <a class="link" href="//mstore.gm99.com?gameId=49" target="_blank" @click="showSubMenu = false"><span>儲值購點</span></a>
          <a class="link" href="//www.facebook.com/lhhx.gm99" target="_blank" @click="showSubMenu = false"><span>遊戲社群</span></a>
          <a class="link" href="//service.gm99.com/" target="_blank" @click="showSubMenu = false"><span>客服中心</span></a>
          <a href="javascript:void(0);" class="music" v-if="!isMobile"><span class="music-icon" @click="controlMusic"></span></a>
        </div>
      </transition>
              <audio ref="audio" preload="auto" webkit-playsinline="true" playsinline="true" crossOrigin="anonymous" :src="musicLink" loop autoplay></audio>
    </section>
  </header>
</template>

<script>
import { GAME_ID, GET_GAME_INFO, SET_NAV_ARTICLE_TYPE } from '../store/config'
import { getUrlParam } from '../utils/utils'
import { mapGetters, mapMutations } from 'vuex'
import musicLink from '../assets/img/music.mp3'
export default {
  data () {
    return {
      showSubMenu: false,
      musicLink,
      hasInitMusic: false,
      musicPlay: false
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'gameInfo',
      'navArticleType'
    ]),
    isMobile () {
      return this.deviceType === 'mobile'
    },
    newsActive () {
      return this.navArticleType === 'news' || this.navArticleType === 'all' || this.navArticleType === 'guides'
    }
  },
  created () {
    this.$store.dispatch(GET_GAME_INFO, GAME_ID)
    this.setNavArticleType(getUrlParam('type') || '')
  },
  mounted () {
    window.addEventListener('click', () => {
      if (!this.hasInitMusic) {
        this.hasInitMusic = true
        this.controlMusic()
      }
    })
  },
  methods: {
    toSetNavArticleType (type) {
      this.showSubMenu = false
      this.setNavArticleType(type)
    },
    controlMusic () {
      this.musicPlay ? this.$refs.audio.pause() : this.$refs.audio.play()
      this.musicPlay = !this.musicPlay
    },
    ...mapMutations({
      'setNavArticleType': SET_NAV_ARTICLE_TYPE
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/header.scss";
</style>
